import React from 'react';
import { CardHeader, TAGTypography } from '../../..';

var ImageLeftCardHeader = function ImageLeftCardHeader(_ref) {
  var cardContentText = _ref.cardContentText,
      cardTitle = _ref.cardTitle;
  return React.createElement(CardHeader, {
    sx: {
      flexGrow: 1,
      pb: 0,
      pt: cardContentText ? 2 : 0
    },
    disableTypography: true,
    title: React.createElement(TAGTypography, {
      variant: "h3",
      color: "text.primary",
      sx: {
        marginBottom: '16px'
      }
    }, cardTitle)
  });
};

export default ImageLeftCardHeader;